export default __webpack_public_path__ + "static/media/card-m-review@2x.0e6edb9a.png";